import '../Modal.scss';
export class CloseTicketModalController {
    static $inject = ['close', 'ticket', 'tags', 'hasTags', 'isTagsRequired'];
    constructor(close, ticket, tags, hasTags, isTagsRequired) {
        this.close = close;
        this.ticket = ticket;
        this.tags = tags;
        this.selectedTags = [];
        this.hasTags = hasTags;
        this.isTagsRequired = isTagsRequired;
        this.mustInputTag = this.isTagsRequired && this.tags.length > 0;
        this.inputTags = [];
        this.init();
    }
    init() {
        if (!this.ticket) {
            this.close();
        }
    }
    updateTagsInput() {
        this.selectedTags = this.inputTags.map(({ label }) => label);
    }
}
CloseTicketModalController.$inject = ['close', 'ticket', 'tags', 'hasTags', 'isTagsRequired'];
